<template>
    <v-alert
        :type="type"
        :border="border"
        :class="`${bodyClass} ${textBodyClass}`"
        :color="calculatedColor"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot></slot>
    </v-alert>
</template>

<script>
export default {
    name: 'KpAlert',

    props: {
        /**
         * type: success|info|warning|error|null
         * the type adds automatically an icon and color
         */
        type: {
            type: String,
            default: null,
        },
        /**
         * successColor: overrides the default color for the success type
         */
        successColor: {
            type: String,
            default: null,
        },
        /**
         * infoColor: overrides the default color for the info type
         */
        infoColor: {
            type: String,
            default: 'var(--light-blue-color)',
        },
        /**
         * warningColor: overrides the default color for the warning type
         */
        warningColor: {
            type: String,
            default: 'var(--warn-bg-color)',
        },
        /**
         * errorColor: overrides the default color for the error type
         */
        errorColor: {
            type: String,
            default: 'var(--error-bg-color)',
        },
        /**
         * color: overrides the color of a chosen type
         */
        color: {
            type: String,
            default: null,
        },
        bodyClass: {
            type: String,
            default: 'kp-alert-body',
        },
        border: {
            type: String,
            default: 'left',
        },
    },
    computed: {
        calculatedColor() {
            let color = null;
            switch (this.type) {
                case 'success':
                    color = this.successColor;
                    break;
                case 'info':
                    color = this.infoColor;
                    break;
                case 'warning':
                    color = this.warningColor;
                    break;
                case 'error':
                    color = this.errorColor;
                    break;
            }
            if (this.color) {
                color = this.color;
            }

            return color;
        },

        textBodyClass() {
            return this.type ? `${this.type}-text` : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.kp-alert-body {
    color: white;
    &.warning-text {
        color: var(--warn-text-color);
        :deep(.v-alert__icon) {
            background-color: var(--warn-text-color);
        }
        :deep(.v-alert__dismissible) {
            .v-icon {
                background-color: var(--warn-text-color);
            }
        }
        :deep(.v-alert__border) {
            opacity: 1;
        }
    }

    &.error-text {
        color: var(--error-text-color);
        :deep(.v-alert__icon) {
            background-color: var(--error-text-color);
        }
        :deep(.v-alert__dismissible) {
            .v-icon {
                background-color: var(--error-text-color);
            }
        }
        :deep(.v-alert__border) {
            opacity: 1;
        }
    }

    :deep(.v-alert__icon) {
        margin-right: 2px;
    }
    :deep(.v-alert__content) {
        h4 {
            font-size: 1rem;
            font-weight: bold;
            margin-top: 2px;
            margin-bottom: 1.2em;
        }
        p {
            font-size: 1rem;
            margin-bottom: 1.1em;
            line-height: calc(1rem * 1.2);
        }
        a {
            color: inherit;
            text-decoration: underline;
        }
    }
}
</style>
